//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CategoriasAPI from '@/api/promotores/cursos/categorias.api'
import CursosAPI from '@/api/promotores/cursos.api'
import CursoForm from './CursoForm'
import ColumnsSelect from '@/components/ColumnsSelect'

export default {
	components: { ColumnsSelect },

  data() {
    return {
			visible_columns: [
				'id', 'nombre', 'categoria', 'especialidades', 'documento', 'video', 'created_at'
			],
			columns: [
				{ name: "id", label: "Id", field: "id", sortable: true, align: "left", style: "width: 10px", required: true },
				{ 
					name: 'nombre', 
					field: 'nombre', 
					label: 'Nombre', 
					sortable: true, 
					required: true,
					align: "left",
					classes: "bg-grey-2 ellipsis",
          style: "width: 350px",
          headerClasses: "bg-primary text-white",
				},
				{ name: 'examen', field: 'examen', label: 'Examen', align: 'left', },
				{ name: 'categoria', field: 'categoria', label: 'Categoria', align: 'left', },
				{ name: 'especialidades', field: 'especialidades', label: 'Especialidades', align: 'left', },
				{ name: "video", label: "Vídeo", field: "video", align: "center", style: 'width: 10px' },
				{ name: "documento", label: "Documento", field: "documento", align: "center", style: 'width: 10px' },
				{ name: "destacado", label: "Destacado", field: "destacado", align: "left", },
				{ name: "created_at", label: "Creación", field: "created_at", align: "left", style: 'width: 200px' },
			],
      categoria: {},
      cursos: [],
      loading: false,
			pagination: {
				sortBy: "id",
        descending: true,
        page: 1,
        rowsPerPage: 10,
        rowsNumber: 10,
			},
			per_page_options: [10, 20, 30, 40, 50, 100],
    };
  },

	async mounted() {
		await this.loadCategoria();
		this.loadCursos();
	},

	methods: {
		async loadCategoria() {
			try {
				this.loading = true
				this.categoria = await CategoriasAPI.get(this.$route.params.categoria)
			} finally {
				this.loading = false
			}
		},

		async loadCursos(payload = {}) {
			const pagination = payload && payload.pagination ? payload.pagination : this.pagination
			
			try {
				this.loading = true
				const { data, ...response } = await CursosAPI.all({
					page: pagination.page,
					limit: pagination.rowsPerPage,
					order: {
						column: pagination.sortBy,
						direction: pagination.descending ? "desc" : "asc"
					},
					categoria: this.categoria.id
				})
				
				this.pagination = {
					page: response.current_page,
					rowsPerPage: Number(response.per_page),
					rowsNumber: response.total,
					sortBy: pagination.sortBy,
					descending: pagination.descending,
				}
				
				this.cursos = data
			} finally {
				this.loading = false
			}
		},

		crearCurso() {
			this.$q.dialog({
				component: CursoForm,
				curso: {
					categoria_id: this.categoria.id
				}
			})
				.onOk((curso) => {
					this.loadCursos()
				})
		},

		editCurso(curso) {
			this.$q.dialog({
				component: CursoForm,
				curso
			})
				.onOk((curso) => {
					this.loadCursos()
				})
		},
	}
};
